(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/takeWhile', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/takeWhile'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.takeWhile, global.convert);
    global.takeWhile = mod.exports;
  }
})(this, function (exports, _takeWhile2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.takeWhile = undefined;

  var _takeWhile3 = _interopRequireDefault(_takeWhile2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Creates a slice of array with elements taken from the beginning.
   * Elements are taken until predicate returns falsey.
   * The predicate is invoked with three arguments: (value, index, array).
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @example takeWhile({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', v => v < 2) // => { nested: { prop: [1] } }
   * @see {@link https://lodash.com/docs#takeWhile|lodash.takeWhile} for more information.
   * @since 0.3.0
   */
  var takeWhile = (0, _convert.convert)(_takeWhile3.default);
  exports.takeWhile = takeWhile;
  exports.default = takeWhile;
});